import numeral from 'numeral';

// ----------------------------------------------------------------------

// export function fCurrency(number, currency = 'ريال', digits = 2) {
//   const digitsFormat = digits === 4 ? '0,0.00[00]' : '0,0.00';
//   return `${numeral(number).format(Number.isInteger(number) ? '0,0' : digitsFormat)} ${currency}`;
// }

export function fCurrency(number, currencyIcon = `/static/SAR-Icon-light.png`, digits = 2, asString = false) {
  const digitsFormat = digits === 4 ? '0,0.00[00]' : '0,0.00';
  const formattedNumber = numeral(number).format(Number.isInteger(number) ? '0,0' : digitsFormat);

  // If asString is true, return an HTML string for use in dangerouslySetInnerHTML
  if (asString) {
    return currencyIcon
      ? `<span style="white-space: nowrap; display: inline-flex; align-items: center; gap: 5px;">
          ${formattedNumber}
          <img src="${currencyIcon}" alt="Currency Icon" style="width: 16px; height: 16px; vertical-align: middle; margin-left: 5px;">
        </span>`
      : formattedNumber;
  }

  // Otherwise, return JSX for normal React usage
  return (
    <span style={{ whiteSpace: 'nowrap', display: 'inline-flex', alignItems: 'center', gap: '5px' }}>
      {formattedNumber}
      {currencyIcon && (
        <img
          src={currencyIcon}
          alt="Currency Icon"
          style={{ width: '16px', height: '16px', verticalAlign: 'middle' }}
        />
      )}
    </span>
  );
}

export function fQty(number) {
  return numeral(number).format('0,0.[0000]');
}

export function fPercent(number) {
  return numeral(number / 100).format('0.0%');
}

export function fNumber(number) {
  if (!number || number === 0) return '';
  if (number < 0) return `(${numeral(Math.abs(number)).format('0,0.00')})`;
  return numeral(number).format('0,0.00');
}

export function fShortenNumber(number) {
  return numeral(number).format('0.00a').replace('.00', '');
}

export function jShortenNumber(number) {
  return numeral(number).format('0.00').replace('.00', '');
}

export function fData(number) {
  return numeral(number).format('0.0 b');
}
